import TicketFormItem from '@/components/event-payment/ticket-form-item';
import { CurrencyCode, WithLang } from '@/types/general/base';
import { TicketSelectOption } from '@/types/tickets';

interface Props {
    ticketOptions: TicketSelectOption[];
    onSlide: () => void;
    currencyCode: CurrencyCode;
}

export default function TicketForm(props: WithLang<Props>) {
    return (
        <div className="h-fit min-w-full px-2 py-2 transition-transform duration-200 sm:px-4">
            {props.ticketOptions
                ?.sort((a, b) => a.price - b.price)
                .map((item, index) => (
                    <TicketFormItem
                        lang={props.lang}
                        currencyCode={props.currencyCode}
                        key={index}
                        ticketOption={item}
                    />
                ))}
        </div>
    );
}
